import { render, staticRenderFns } from "./AppointmentsByUINComponent.vue?vue&type=template&id=6e01cbae"
import script from "./AppointmentsByUINComponent.vue?vue&type=script&lang=js"
export * from "./AppointmentsByUINComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports